import React, { useEffect, useState } from 'react';
import { Badge } from '../../components/Circle';
import { Flex } from '../../components/Flex';
import { Label, Title } from '../../components/Text';
import { CircleIcon } from '../../icons/CircleIcon';
import { filter } from 'lodash';
import { Table } from '../../components/Table';
import { Checkbox } from '../../components/Checkbox';


const UploadDetails = ({ dataSource=[] }) => {
    const [ state, setState ] = useState({ data: [], cache: [] });

    useEffect(() => {
        setState({ data: dataSource, cache: dataSource });
    }, []);

    const onFilterData = (checked) => {
        setState(state => ({ ...state, data: checked ? filter(state.cache, o => o.status != 204) : state.cache }));
    };

    const columns = [
        {
            title: <CircleIcon size={16} />,
            dataIndex: 'status',
            render: (text, record, index) =>
                <>
                    {text == 200 || text == 201 ? <Badge color="#55C36D" /> : <Badge color="var(--sp-error-hover-color)" />}
                </>,
            width: 56,
            sorter: (a, b) => { if (a && a.hasOwnProperty("status") && a.status) return a.status - b.status }
        },
        {
            title: "Organization alias",
            dataIndex: 'orgAlias',
            width: 180,
            sorter: (a, b) => { if (a && a.hasOwnProperty("orgAlias") && a.orgAlias) return a.orgAlias.localeCompare(b.orgAlias) }
        },
        {
            title: "Result",
            dataIndex: 'message',
            sorter: (a, b) => { if (a && a.hasOwnProperty("message") && a.message) return a.message.localeCompare(b.message) }
        }
    ];


    return(
        <>
            <Title h4 margin={{ bottom: "8px" }}>Results of uploading organizations contracts</Title>
            <Flex height={dataSource.length > 6 ? "calc(100vh - 368px)" : null} margin={{ bottom: "16px" }}>
                <Table
                    columns={columns}
                    dataSource={state.data}
                    loading={false}
                    pagination={false}
                    scroll={{ y: true }}
                    showSorterTooltip={false}
                    locale={{ emptyText: <Label size="18px" bold color="#D7E3F7">no data</Label> }}
                />
            </Flex>
            <Checkbox onChange={(e) => onFilterData(e.target.checked)}>Show only updated contracts</Checkbox>
        </>
    )
};

export { UploadDetails };